// Cross-frame signal for a finished KYC submission (b.ii.2).
//
// The KYC form runs in the HR dashboard's modal iframe while the ReadyCash
// widget stays in its own iframe, so the form cannot tell the widget directly
// that the borrower is done. Both frames are same-origin — that is already how
// the access token reaches the form (see app.tsx) — so localStorage is the
// shared channel: the browser raises a `storage` event in every *other*
// same-origin document whenever a key changes.
export const KYC_COMPLETED_STORAGE_KEY = 'kyc.completed';

// A `storage` event only fires when the value actually changes, so two
// completions in the same millisecond would be swallowed if we wrote a bare
// timestamp. The counter makes every write distinct.
let signalCount = 0;

export function notifyKycCompleted(): void {
  signalCount += 1;
  localStorage.setItem(KYC_COMPLETED_STORAGE_KEY, `${Date.now()}-${signalCount}`);
}

export function onKycCompleted(callback: () => void): () => void {
  const handler = (event: StorageEvent) => {
    if (event.key === KYC_COMPLETED_STORAGE_KEY) callback();
  };

  window.addEventListener('storage', handler);

  return () => window.removeEventListener('storage', handler);
}
